import { VContainer } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VContainer,{staticClass:"layout",attrs:{"fluid":""}},[_c(VLayout,{attrs:{"column":"","wrap":"","align-center":"","justify-center":""}},[_c(VProgressCircular,{attrs:{"size":80,"width":8,"color":"primary","indeterminate":""}}),_c('span',[_vm._v("Connecting your Microsoft account...")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }